/**
 * Role Configuration for PropelX
 * Defines landing routes, sidebar visibility, and allowed routes per role
 * as specified in Section 21 of central_oauth.pdf
 */

const allStandardRoutes = [
  '/dashboard',
  '/projects',
  '/projects/:id',
  '/my-tasks',
  '/team-tasks',
  '/rfps',
  '/rfps/:id',
  '/rfps/:rfpId/proposals',
  '/proposals',
  '/proposals/:id',
  '/rfp-dashboard',
  '/ai-assistant',
  '/reports',
  '/notifications',
  '/profile',
];

export const rolesConfig = {
  // ECI Domain Roles
  project_director: {
    landingRoute: '/dashboard',
    showSidebar: true,
    allowedRoutes: [...allStandardRoutes, '/admin/users'],
  },
  project_manager: {
    landingRoute: '/dashboard',
    showSidebar: true,
    allowedRoutes: allStandardRoutes,
  },
  site_engineer: {
    landingRoute: '/dashboard',
    showSidebar: true,
    allowedRoutes: allStandardRoutes,
  },
  field_engineer: {
    landingRoute: '/my-tasks',
    showSidebar: true,
    allowedRoutes: ['/my-tasks', '/projects', '/projects/:id', '/notifications', '/profile'],
  },
  qaqc_inspector: {
    landingRoute: '/dashboard',
    showSidebar: true,
    allowedRoutes: allStandardRoutes,
  },
  hse_officer: {
    landingRoute: '/dashboard',
    showSidebar: true,
    allowedRoutes: allStandardRoutes,
  },
  contractor: {
    landingRoute: '/my-tasks',
    showSidebar: true,
    allowedRoutes: ['/my-tasks', '/projects', '/projects/:id', '/notifications', '/profile'],
  },
  client_rep: {
    landingRoute: '/dashboard',
    showSidebar: true,
    allowedRoutes: ['/dashboard', '/projects', '/projects/:id', '/team-tasks', '/rfp-dashboard', '/reports', '/notifications', '/profile'],
  },

  // Central OAuth generic roles mapping
  Admin: {
    landingRoute: '/dashboard',
    showSidebar: true,
    allowedRoutes: [...allStandardRoutes, '/admin/users'],
  },
  Tester: {
    landingRoute: '/dashboard',
    showSidebar: true,
    allowedRoutes: allStandardRoutes,
  },
  Viewer: {
    landingRoute: '/dashboard',
    showSidebar: true,
    allowedRoutes: ['/dashboard', '/projects', '/projects/:id', '/reports', '/notifications', '/profile'],
  },
};

export default rolesConfig;
